const React = require('react')

import {
  Button,
  Col,
  Glyphicon,
  Image,
  Label,
  Panel,
  Row,
} from 'react-bootstrap'
import gtagHelper from '../../utils/gtagHelper'
import SiteModalMobile from './SiteModalMobile'
const TextTruncate = require('react-text-truncate')
const basePath = window.basePath || '';

export default class SiteMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      isErrorImage: false
    }
    this.handleAdd = this.handleAdd.bind(this)
    this.handleHideModal = this.handleHideModal.bind(this)
    this.handleShowModal = this.handleShowModal.bind(this)
  }

  handleShowModal() {
    gtagHelper.sendSitePreviewEvent(this.props.site, this.props.tags)
    this.setState({
      showModal: true
    })
  }

  handleHideModal() {
    this.setState({
      showModal: false
    })
  }

  handleAdd() {
    this.setState({
      showModal: false
    }, this.props.onAdd)
  }

  setErrorImage = () => {
    this.setState({
      ...this.state,
      isErrorImage: true
    })
  }

  render() {
    return (
      <Panel style={{ position: 'relative', marginLeft: '-30px', marginRight: '-30px', marginBottom: 0 }}>
        <Panel.Body style={{ padding: 10 }}>
          <Row style={{ marginLeft: 0 }}>
            <Col>
              {this.state.showModal &&
                <SiteModalMobile
                  onHide={this.handleHideModal}
                  item={this.props.item}
                  show={this.state.showModal}
                  site={this.props.site}
                  tags={this.props.tags}
                  thumbnails={this.props.pageThumbnails}
                  source={this.props.source}
                >
                {this.props.source == 'lessonplanner' &&
                  <Button
                    bsStyle='success'
                    onClick={this.handleAdd}>
                    + Add Lesson Plan
                  </Button>
                }
                {!this.props.item.is_owned && this.props.source != 'lessonplanner' &&
                  <Button
                    bsStyle='success'
                    onClick={this.handleAdd}>
                      + Add
                  </Button>
                }
                {this.props.item.is_owned && this.props.source != 'lessonplanner' &&
                  <Button
                    bsStyle='success'
                    onClick={this.handleAdd}
                    style={{ bottom: '0px' }}>
                    <Glyphicon glyph='ok'/>&nbsp;
                    Added
                  </Button>
                }
                </SiteModalMobile>
              }
              <a
                href="javascript:;"
                onClick={this.handleShowModal}>
                {!this.props.mainThumbnail &&
                <Image
                  className='img'
                  style={{ margin: '0 auto' }}
                  src={`${basePath}/img/placeholder.png`}
                  responsive
                  rounded
                  width={255}
                  height={169}
                />
                }
                {this.props.mainThumbnail &&
                <Image
                  className='img pull-left'
                  style={{ margin: '0 auto', width: 90, height: 100 }}
                  onError={this.setErrorImage}
                  src={!this.state.isErrorImage?this.props.mainThumbnail.url:`${basePath}/img/placeholder.png`}
                  responsive
                  rounded
                  width={255}
                  height={169}
                />
                }
              </a>
            </Col>
            <Col style={{ float: 'right', width: '70%', height: 'auto', paddingRight: 10 }}>
            <h5 style={{height: 30, marginTop: 0, marginBottom: 8}}>
                <a
                  href="javascript:;"
                  onClick={this.handleShowModal}>
                  <TextTruncate
                    line={2}
                    text={this.props.site.title}
                  />
                </a>
              </h5>
              <div style={{display: 'block', height: '40px'}}>
                <TextTruncate
                  line={1}
                  text={this.props.site.author_name}
                />
                <small>
                  <TextTruncate
                    line={1}
                    text={this.props.site.school_name}
                  />
                </small>
                <small>
                <Label bsStyle='default'>
                  <Glyphicon glyph="save" />
                  {
                    this.props.item.download_count
                    ? ` ${this.props.item.download_count}`
                    : ''
                  }
                </Label>
                </small>
              </div>

            </Col>
          </Row>
        </Panel.Body>
      </Panel>
    )
  }
}